export function cookiePreferencesButton(parentSelector: string) {
    const container= document.querySelector(parentSelector);

    if (container) {
        const a = document.createElement("a");
        a.setAttribute("href", "#");
        a.setAttribute("title", "Cookie-voorkeuren");
        a.setAttribute("class", "button-cookie-settings");
        a.text = "Cookie-voorkeuren";
        container.appendChild(a);
    }
}
